import React from 'react';
import { Card, Col, Row, Button, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '../../common/Flex';

const PerformanceGreetings = ({ 
  totalOrders, 
  dateRange, 
  onDatePresetChange, 
  selectedPreset, 
  datePresets 
}) => {
  const formatDateRange = () => {
    if (!dateRange[0] || !dateRange[1]) return 'Sin rango seleccionado';
    
    const start = dateRange[0].toLocaleDateString('es-ES', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
    const end = dateRange[1].toLocaleDateString('es-ES', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
    
    return `${start} - ${end}`;
  };

  return (
    <Card className="bg-100 shadow-none border mb-3">
      <Card.Body className="py-3">
        <Row className="g-0 justify-content-between align-items-center">
          <Col sm="auto">
            <Flex alignItems="center">
              <div>
                <h6 className="text-primary fs-10 mb-0">Bienvenido al</h6>
                <h4 className="text-primary fw-bold mb-0">
                  Dashboard de Performance
                </h4>
                <p className="text-muted fs-11 mb-0">
                  {totalOrders} órdenes en el período seleccionado
                </p>
              </div>
            </Flex>
          </Col>
          
          <Col md="auto" className="mb-3 mb-md-0">
            <Row className="g-3 gy-md-0 h-100 align-items-center">
              <Col xs="auto">
                <h6 className="text-700 mb-0 text-nowrap">Período:</h6>
                <small className="text-muted d-block">{formatDateRange()}</small>
              </Col>
              <Col md="auto">
                <ButtonGroup size="sm">
                  {Object.entries(datePresets).map(([key, preset]) => (
                    <Button
                      key={key}
                      variant={selectedPreset === key ? 'primary' : 'outline-primary'}
                      onClick={() => onDatePresetChange(key)}
                      className="fs-11"
                    >
                      {preset.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default PerformanceGreetings; 